/**
 * PontaSlaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {PontaSla} from '@/model/resource/PontaSla'

/* TODO: review generated class */
@HttpExclude()
export class PontaSlaCollection extends PageCollection<PontaSla> {
  constructor() {
    super(PontaSla)
  }

  queryAsPage() {
    return this.listPontaSla()
  }

  async listPontaSla() {
    return await Request.get(`/admin/ponta-sla`, {params: this.params})
      .name('listPontaSla')
      .as(this)
      .getResponse()
  }

  async listCsvPontaSla() {
    return await Request.get(`/admin/ponta-sla/csv`, {params: this.params})
      .name('listCsvPontaSla')
      .as(this)
      .getResponse()
  }
}
